import React, { useState } from 'react';
import { Box } from '@mui/material';
import { 
  ClientSelector, 
  GenerateReportButton, 
  ReportDescription, 
  generateNoAccessDocument, 
  sampleClientData 
} from './NoAccessComponents';
import { getJobs } from '../../../sevices/jobApi';

function NoAccessNotice({ handleClientNoticeReport, isLoading }) {
  const [selectedClient, setSelectedClient] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClientChange = (value) => {
    console.log(value);
    setSelectedClient(value);
  };

  const handleGenerateDocument = async () => {
    if (!selectedClient) return;
    
    setLoading(true);
    try {
      let clientData = {
        clientName: "",
        buildings: [],
      };
      getJobs({
        pageSize: 100,
        page: 1,
        client: `&client_id=${selectedClient}`,
        pagination: false,
        noAccess: "&no_access_job=true",
      })
        .then((res) => {
          console.log(res);
          const {response_data}=res.data.data;
          const gropedArray = Object.groupBy(
            response_data,
            (job) => job.building_id
          );
          clientData.clientName = response_data[0].client_name;
        // Loop through the grouped array by building_id
        Object.entries(gropedArray).forEach(([buildingId, jobs]) => {
          console.log(`Building ID: ${buildingId}`);
          clientData.buildings.push({
            id: buildingId,
            name: jobs[0].address,
            units: jobs.map((job) => {
            return {
              unit: job.apartment,
              // job.no_access_dates is an array of dates, sort descending (latest first), pick the first as firstAttempt
              ...(job.no_access_dates && job.no_access_dates.length >= 2
                ? {
                    firstAttempt: [...job.no_access_dates].sort(
                      (a, b) => new Date(b) - new Date(a)
                    )[1],
                    secondAttempt: [...job.no_access_dates].sort(
                      (a, b) => new Date(b) - new Date(a)
                    )[0],
                  }
                : {
                    firstAttempt: job.no_access_dates[0],
                    secondAttempt: "",
                  }),
              status: "Access Denied",
            };
          }),
          });
        });
        console.log(clientData);
         generateNoAccessDocument(clientData);
        })
        .catch((err) => {
          console.log(err);
        });
       
      // const clientData = sampleClientData[selectedClient];
      // await generateNoAccessDocument(clientData);
    } catch (error) {
      console.error("Error generating document:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="report-card-content">
      <ReportDescription />
      <Box className="report-action">
        <ClientSelector 
          selectedClient={selectedClient}
          handleClientChange={handleClientChange}
          isLoading={isLoading}
        />
        <GenerateReportButton 
          onClick={handleGenerateDocument}
          disabled={!selectedClient || loading || isLoading}
          loading={loading}
        />
      </Box>
    </Box>
  );
}

export default NoAccessNotice;